/**
 * use-supabase-mutations.ts — Write hooks (create atom, post discussion)
 * Split from use-supabase.ts per #566.
 */
import { getSupabase } from "@/lib/supabase";
import { createLogger } from '@/lib/logger';
import { useMutation, type UseMutationResult } from './use-supabase-core';
import type { AtomRow, DiscussionMessageRow } from "@shared-types/api-rows";

const log = createLogger('Mutations');

export function useCreateAtom(): UseMutationResult<
  Record<string, unknown>,
  { atom: AtomRow }
> {
  return useMutation(async (input) => {
    const sb = getSupabase();
    const { data, error } = await sb
      .from("idea_atoms")
      .insert(input)
      .select()
      .single();
    if (error) throw new Error(error.message);
    log.info('atom created', { id: (data as AtomRow).id });
    return { atom: data as AtomRow };
  });
}

export function usePostDiscussion(): UseMutationResult<
  { topicId: string; author_user_id: string; content: string; reply_to_id?: string },
  { message: DiscussionMessageRow }
> {
  return useMutation(async (input) => {
    const { topicId, ...body } = input;
    const sb = getSupabase();
    const { data, error } = await sb
      .from("discussion_messages")
      .insert({ topic_id: topicId, ...body })
      .select()
      .single();
    if (error) throw new Error(error.message);
    return { message: data as DiscussionMessageRow };
  });
}
